import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./datatable.jsx";
import { getAllOrdersApiRedux, getAllEmployeeRedux } from "../../actions/index";
import { Link } from "react-router-dom";
import UpdateRequestModal from "./updateRequestModal";
import {
  getSingleOrderApi,
  updateAllOrdersApi,
} from "../../firebase/firebase.utils.js";
import { GetAllShippingAddress } from "../../actions/get1688Data";
import { get1688TrackingStatus2 } from "../../actions/get1688Data.js";
import { connect } from "react-redux";
import { Search } from "react-feather";
import { ClipLoader } from "react-spinners";
import { updateOrdersWithTrackingNoRedux } from "../../actions/index";
import { notifyWarning, notifyError } from "../../utils/notify";
export class New extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchFor: "",
      toggleModal: true,
      toggleDeleteModal: true,
      order: null,
      loader1: false,
      shippingAddress: [],
    };
  }

  componentDidMount = async () => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);

    // Format: YYYY-MM-DD (consistent everywhere)
    const endDate = today.toISOString().split("T")[0];
    const startDate = past.toISOString().split("T")[0];
    this.setState({
      customStart: startDate,
      customEnd: endDate,
    });
    console.log(this.props.match.params.orderStatus);
    this.props.getAllEmployeeRedux();
    if (this.props.match.params.orderStatus == "all-orders") {
      this.props.getAllOrdersApiRedux("", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "new") {
      this.props.getAllOrdersApiRedux("pending", startDate, endDate);
      let shippingAddress = await GetAllShippingAddress();
      console.log(shippingAddress);
      this.setState({
        shippingAddress: shippingAddress,
      });
    } else if (this.props.match.params.orderStatus === "purchased") {
      this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
    } else if (
      this.props.match.params.orderStatus === "received-in-warehouse"
    ) {
      this.props.getAllOrdersApiRedux(
        "Received in Warehouse",
        startDate,
        endDate,
      );
    } else if (this.props.match.params.orderStatus === "ready-for-fly") {
      this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "bangladesh-customs") {
      this.props.getAllOrdersApiRedux("Bangladesh customs", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "custom-released") {
      this.props.getAllOrdersApiRedux(
        "Bangladesh warehouse",
        startDate,
        endDate,
      );
    } else if (this.props.match.params.orderStatus === "Zapai-warehouse") {
      this.props.getAllOrdersApiRedux("Zapai warehouse", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "delivered") {
      this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "rejected") {
      this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "picked-orders") {
      this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
    }
  };

  componentWillReceiveProps = async (nextProps) => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);

    // Format: YYYY-MM-DD (consistent everywhere)
    const endDate = today.toISOString().split("T")[0];
    const startDate = past.toISOString().split("T")[0];

    if (
      this.props.match.params.orderStatus !== nextProps.match.params.orderStatus
    ) {
      this.setState({
        customStart: startDate,
        customEnd: endDate,
        searchFor: "",
        order1688: null,
      });
      if (nextProps.match.params.orderStatus === "all-orders") {
        this.props.getAllOrdersApiRedux("", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "new") {
        this.props.getAllOrdersApiRedux("pending", startDate, endDate);
        if (this.state.shippingAddress.length == 0) {
          let shippingAddress = await GetAllShippingAddress();
          console.log(shippingAddress);
          this.setState({
            shippingAddress: shippingAddress,
          });
        }
      } else if (nextProps.match.params.orderStatus === "purchased") {
        this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
      } else if (
        nextProps.match.params.orderStatus === "received-in-warehouse"
      ) {
        this.props.getAllOrdersApiRedux(
          "Received in Warehouse",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "ready-for-fly") {
        this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "custom-released") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh warehouse",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "Zapai-warehouse") {
        this.props.getAllOrdersApiRedux(
          "Zapai warehouse",
          startDate,
          endDate,
        );
      } else if (nextProps.match.params.orderStatus === "delivered") {
        this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "rejected") {
        this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "picked-orders") {
        this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
      }
    }
  };

  startToggleModal = async (order) => {
    if (order == null) {
      this.setState({
        toggleModal: !this.state.toggleModal,
        order: null,
      });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        order,
      });
    }
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  applyRange = async () => {
    const { customStart, customEnd } = this.state;
    this.setState({
      order1688: null,
      searchFor: "",
    });
    let startDate = customStart;
    let endDate = customEnd;
    console.log(customStart);
    console.log(customEnd);
    if (customStart && customEnd) {
      if (this.props.match.params.orderStatus == "all-orders") {
        this.props.getAllOrdersApiRedux("", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "new") {
        this.props.getAllOrdersApiRedux("pending", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "purchased") {
        this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
      } else if (
        this.props.match.params.orderStatus === "received-in-warehouse"
      ) {
        this.props.getAllOrdersApiRedux(
          "Received in Warehouse",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "ready-for-fly") {
        this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "custom-released") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh warehouse",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "Zapai-warehouse") {
        this.props.getAllOrdersApiRedux(
          "Zapai warehouse",
          startDate,
          endDate,
        );
      } else if (this.props.match.params.orderStatus === "delivered") {
        this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "rejected") {
        this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "picked-orders") {
        this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
      }
    }
  };

  handleSubmit2 = async (e) => {
    e.preventDefault();
    if (!this.state.searchFor) {
      notifyWarning("Order Id cant be empty.");
      return;
    }
    let order = await getSingleOrderApi(this.state.searchFor);
    if (order) {
      this.setState({
        order1688: order,
      });
    } else {
      notifyError("Sorry no order is found with this order Id");
    }
    console.log("handle submit 2 is getting called!");
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  getAllTrackingNo = async (orders) => {
    if (orders && orders.length > 0) {
      if (this.state.loader1) {
        return;
      }
      this.setState({
        loader1: true,
      });
      let newOrders = [];
      for (let i = 0; i < orders.length; i++) {
        const order = orders[i];
        let trackingArray = await get1688TrackingStatus2(order.orderNumber);
        let trackingObj = trackingArray ? trackingArray[0] : null;

        console.log(trackingObj);
        if (trackingObj && trackingObj.logisticsBillNo) {
          newOrders.push({ ...order, trackingNo: trackingObj.logisticsBillNo });
        }
      }
      this.props.updateOrdersWithTrackingNoRedux(newOrders);

      this.setState({
        loader1: false,
      });
      console.log(newOrders);
    } else {
      notifyWarning("At least select one order to get 1688 Tracking No");
    }
  };

  render() {
    const { open, customStart, customEnd } = this.state;
    let { ordersApi } = this.props;
    let orders = [];
    let totalWeight = 0;
    let totalRmb = 0;
    let totalBdt = 0;
    let totalExpense = 0;
    let totalProfit = 0;

    if (ordersApi.length > 0) {
      if (this.props.match.params.orderStatus == "new") {
        orders = ordersApi.filter((order) => order.agentStatus !== "Picked");
        orders = orders.sort((a, b) => b.time - a.time);
      } else {
        orders = ordersApi.sort((a, b) => b.time - a.time);
      }
      orders.map((order) => {
        totalWeight +=
          order.items && order.items[0] && order.items[0].weight
            ? parseFloat(order.items[0].weight)
            : 0;
        if (
          order.creationTime1688 &&
          order.creationTime1688.totalSuccessAmount
        ) {
          totalRmb += parseFloat(order.creationTime1688.totalSuccessAmount);
          totalExpense += parseFloat(
            order.creationTime1688.totalSuccessAmount * order.exchangeRate,
          )
            ? parseFloat(order.creationTime1688.totalSuccessAmount) *
              order.exchangeRate
            : 0;
        }
        totalBdt +=
          order.orderTotal +
          (order.localShipping ? parseFloat(order.localShipping) : 0);
      });
    }
    totalProfit = totalBdt - totalExpense;
    console.log(this.props);
    const addressIdsToRemove = [
      7244042096, 7272087113, 7266937923, 5519749109, 7171860698, 7272015579,
    ];
    const filteredAddresses = this.state.shippingAddress.filter(
      (item) => !addressIdsToRemove.includes(item.id),
    );
    return (
      <Fragment>
        <UpdateRequestModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          order={this.state.order}
        />

        <Breadcrumb
          title={this.props.match.params.orderStatus}
          parent="1688/tabao Orders"
        />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card" style={{ borderRadius: 10, overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>

                {/* ── PAGE HEADER ── */}
                <div
                  style={{
                    background: "linear-gradient(135deg, #00254c 0%, #18768f 100%)",
                    padding: "20px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}>
                      Pre-Orders
                    </div>
                    <h5 style={{ color: "white", margin: 0, fontWeight: 700, fontSize: 20, textTransform: "capitalize" }}>
                      {this.props.match.params.orderStatus} Orders
                    </h5>
                  </div>
                  <button
                    onClick={() => {
                      let ordersWithOrderNumber = orders.filter(
                        (order) => order.orderNumber && !order.trackingNo,
                      );
                      this.getAllTrackingNo(ordersWithOrderNumber);
                    }}
                    style={{
                      background: "rgba(255,255,255,0.15)",
                      border: "1px solid rgba(255,255,255,0.3)",
                      color: "white",
                      borderRadius: 6,
                      padding: "8px 18px",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: 13,
                      minWidth: 180,
                    }}
                  >
                    {this.state.loader1 ? (
                      <ClipLoader color={"white"} loading={this.state.loader1} size={14} />
                    ) : (
                      "Get 1688 Tracking No"
                    )}
                  </button>
                </div>

                {/* ── CONTROLS ROW ── */}
                <div
                  style={{
                    background: "#f8f9fa",
                    borderBottom: "1px solid #e9ecef",
                    padding: "14px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      name="customStart"
                      value={customStart}
                      onChange={this.handleChange}
                      style={{ borderRadius: 6, maxWidth: 150 }}
                    />
                    <span style={{ color: "#aaa", fontSize: 13 }}>to</span>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      name="customEnd"
                      value={customEnd}
                      onChange={this.handleChange}
                      min={customStart}
                      style={{ borderRadius: 6, maxWidth: 150 }}
                    />
                    <button
                      onClick={this.applyRange}
                      style={{
                        background: "#00254c",
                        color: "white",
                        border: "none",
                        borderRadius: 6,
                        padding: "6px 18px",
                        fontWeight: 600,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      Apply
                    </button>
                  </div>

                  <form
                    className="form-inline"
                    onSubmit={this.handleSubmit2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background: "white",
                      border: "1px solid #dee2e6",
                      borderRadius: 20,
                      padding: "4px 14px",
                    }}
                  >
                    <input
                      className="form-control-plaintext"
                      name="searchFor"
                      value={this.state.searchFor}
                      type="search"
                      placeholder="Search Order Id"
                      style={{ fontSize: 13, outline: "none", minWidth: 180 }}
                      onChange={this.handleSearchBarChange}
                    />
                    <Search
                      size={16}
                      style={{ color: "#aaa", cursor: "pointer", marginLeft: 6 }}
                      onClick={(e) => this.handleSubmit2(e)}
                    />
                  </form>
                </div>

                {/* ── STAT CARDS ── */}
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    padding: "16px 20px",
                    background: "#f4f6f9",
                    borderBottom: "1px solid #e9ecef",
                    flexWrap: "wrap",
                  }}
                >
                  {[
                    { label: "Total Orders", value: orders.length, suffix: "", color: "#6c757d" },
                    { label: "Total Weight", value: parseFloat(totalWeight).toFixed(2), suffix: " kg", color: "#17a2b8" },
                    { label: "Total RMB", value: `¥ ${parseFloat(totalRmb).toFixed(2)}`, suffix: "", color: "#5e72e4" },
                    { label: "Total BDT", value: `Tk ${parseFloat(totalBdt).toFixed(2)}`, suffix: "", color: "#6f42c1" },
                    { label: "Total Expense", value: `Tk ${parseFloat(totalExpense).toFixed(2)}`, suffix: "", color: "#e9534f" },
                    { label: "Total Profit", value: `Tk ${parseFloat(totalProfit).toFixed(2)}`, suffix: "", color: "#28a745" },
                  ].map(({ label, value, suffix, color }) => (
                    <div
                      key={label}
                      style={{
                        background: "white",
                        borderRadius: 8,
                        padding: "10px 16px",
                        flex: 1,
                        minWidth: 120,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                        borderTop: `3px solid ${color}`,
                      }}
                    >
                      <div style={{ color: "#aaa", fontSize: 10, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 3 }}>
                        {label}
                      </div>
                      <div style={{ fontWeight: 700, fontSize: 16, color }}>
                        {value}{suffix}
                      </div>
                    </div>
                  ))}
                </div>

                {/* ── TABLE ── */}
                <div className="card-body" style={{ padding: "0 0 16px 0" }}>
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      startDeleteToggleModal={this.startDeleteToggleModal}
                      history={this.props.history}
                      orderStatus={this.props.match.params.orderStatus}
                      multiSelectOption={false}
                      myData={
                        this.state.order1688 ? [this.state.order1688] : orders
                      }
                      shippingAddress={filteredAddresses}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ordersApi: state.orders.ordersApi,
  };
};

export default connect(mapStateToProps, {
  getAllOrdersApiRedux,
  getAllEmployeeRedux,
  updateOrdersWithTrackingNoRedux,
})(New);
